const CHAT_ALERT = 'Para poder usar el chat de ayuda, es necesario que deshabilites el bloqueo de ventanas emergentes desde la configuracion de tu navegador';
const DEFAULT_CHAT_SUBJECT = 'Chat de ayuda';
const DEFAULT_CHAT_HEIGHT = 380;
const DEFAULT_CHAT_WIDTH = 340;

const defaultChatParams = {
  chatUrl: '',
  chatSubject: '',
  chatSize: {
    width: 0,
    height: 0
  },
}

const getChatParams = (chatWidth, chatHeight) => `
    width=${chatWidth},
    height=${chatHeight},
    location=no,
    menubar=no,
    toolbar=no,
    directories=no,
    scrollbars=no,
    resizable=0,
    top=0,
    left=0
  `;

export const openChatService = (chatParams = defaultChatParams) => {
  const chatUrl = chatParams?.chatUrl;

  if (!chatUrl) return;

  const chatWidth = chatParams?.chatSize?.width || DEFAULT_CHAT_WIDTH;
  const chatHeight = chatParams?.chatSize?.height || DEFAULT_CHAT_HEIGHT;
  const chatSubject = chatParams?.chatSubject || DEFAULT_CHAT_SUBJECT;

  const chatWindowParams = getChatParams(chatWidth, chatHeight);
  const chatWindowService = window.open(chatUrl, chatSubject, chatWindowParams);

  if (!chatWindowService) alert(CHAT_ALERT);
}